import { Omit } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import compose from 'recompose/compose';
import { Arrow, ArrowProps } from './Arrow';
import { ArrowLabel, ArrowLabelProps } from './ArrowLabel';

interface OwnProps
  extends Omit<ArrowProps, 'classes'>,
    Omit<ArrowLabelProps, 'classes' | 'children'> {
  label?: ArrowLabelProps['children'];
  className?: string;
}

interface ArrowWithLabelProps extends OwnProps, WithStyles<typeof styles> {}

const ArrowWithLabelBase: FunctionComponent<ArrowWithLabelProps> = ({
  classes,
  className,
  stops,
  colored = false,
  label,
}) => {
  return (
    <Grid
      container
      item
      className={classNames(classes.root, className)}
      direction="column"
      alignItems="center"
    >
      <Grid
        container
        item
        direction="column"
        alignItems="center"
        justify="center"
      >
        <Grid item className={classes.arrowWrap}>
          <Arrow stops={stops} />
        </Grid>
      </Grid>
      {!!label && (
        <Grid
          container
          item
          alignItems="center"
          justify="center"
          className={classes.autoWidth}
        >
          <Grid item>
            <ArrowLabel colored={colored}>{label}</ArrowLabel>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

// styled
const styles = (theme: Theme) =>
  createStyles({
    arrowWrap: {
      alignItems: 'center',
      display: 'flex',
      // Height of arrow should match line-height of start date/time and end date/time
      fontSize: theme.zeno.typography.subheading.fontSize,
      height: theme.zeno.typography.subheading.lineHeight,
      justifyContent: 'center',
      width: 'auto',
    },
    autoWidth: { width: 'auto' },
    root: {
      width: 'auto',
    },
  });

const enhance = compose<ArrowWithLabelProps, OwnProps>(withStyles(styles));

/**
 * Route arrow with a label
 *
 * @example
 * ⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯>
 *
 * @example
 * ⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯>
 *   Direct
 *
 * @example
 * ⎯⎯⎯⎯⎯⎯⎯⎯o⎯⎯⎯⎯⎯⎯⎯>
 *    SYD
 *
 * @example
 * ⎯⎯⎯⎯⎯⎯o⎯⎯o⎯⎯⎯⎯⎯>
 *  2 stops
 */
export const ArrowWithLabel = enhance(ArrowWithLabelBase);
